import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '../../services/link';

import { margins, colors, fontSizes } from '../home/v3/styledComponents';

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  list-style-type: none;
  font-family: Libre Baskerville;
  font-size: ${fontSizes.l};
  color: ${colors.grey500};
`;

const PageNumber = styled.a`
  cursor: pointer;
  color: ${colors.grey500};
  margin: 0px ${margins.xs};
  user-select: none;
  min-width: 25px;
  ${({ active }) => active && `
    margin-bottom: -2px;
    color: ${colors.black};
    font-size: ${fontSizes.xl};
    min-width: 32px;
  `}
  ${({ hide }) => hide && `
    opacity: 0;
    cursor: initial;
  `}
`;

const Ellipsis = styled.span`
  margin: 0px ${margins.xs};
`;

// const getVisiblePages = (pageCount) => Array.from({ length: pageCount }, (_, i) => i + 1);
const getVisiblePages = (pageCount, activePage) => {
  const pages = [];

  if (activePage > 2) {
    pages.push('...');
  }

  if (activePage > 1) {
    pages.push(activePage - 1);
  }

  pages.push(activePage);

  if (activePage < pageCount) {
    pages.push(activePage + 1);
  }

  if (activePage === 1 && pageCount > 3) {
    pages.push(activePage + 2);
  }

  if (activePage < pageCount - 1) {
    pages.push('...');
  }

  return pages;
};

function Pagination({ activePage, pageCount, getLink }) {
  const visiblePageNumbers = getVisiblePages(pageCount, activePage);
  if (visiblePageNumbers.length <= 1) return null;
  return (
    <Container>
      {visiblePageNumbers.map((number, index) => number === '...' ? (
        <Ellipsis key={`${number + index}`}>...</Ellipsis>
      ) : (
        <Link key={number} style={{ textDecoration: 'none' }} to={getLink(number)}>
          <PageNumber active={number === activePage}>
            {number}
          </PageNumber>
        </Link>
      ))}
    </Container>
  );
}

Pagination.propTypes = {
  activePage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  getLink: PropTypes.func.isRequired,
};

export default Pagination;
